import React from 'react';
import type { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import FeedbackCollector from '@atlaskit/feedback-collector';

import { useSessionData } from '@confluence/session-data';

import { SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE } from '../../../controller/Controller';

const i18n = defineMessages({
	feedbackTitle: {
		id: 'share-and-restrict-dialog.feedback-collector.title',
		defaultMessage: 'Give feedback',
		description: 'Title for the feedback collector',
	},
	feedbackTitleDetails: {
		id: 'share-and-restrict-dialog.feedback-collector.title-details',
		defaultMessage:
			'Overall, how satisfied or dissatisfied are you with your experience sharing and managing access?',
		description: 'Title for the feedback collector',
	},
});

const ENTRYPOINT_ID = '2ecc0711-3ab4-459c-88b9-4c44c9754f0b';
const FEEDBACK_CONTEXT_ID = 'customfield_10047';

export type USDFeedbackCollectorProps = {
	contentId?: string;
	onClose: () => void;
	onSubmit: () => void;
};

export const USDFeedbackCollector: FC<USDFeedbackCollectorProps> = ({
	contentId,
	onClose,
	onSubmit,
}) => {
	const { formatMessage, locale } = useIntl();
	const { displayName, userId, cloudId, edition, environment } = useSessionData();

	const getFeedbackMetadata = (): string => {
		const feedbackMetadata = {
			location: window.location.hostname,
			userId,
			cloudId,
			contentId,
			edition,
			source: SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE,
			environment,
		};
		return JSON.stringify(feedbackMetadata, null, 2);
	};

	return (
		<FeedbackCollector
			onClose={() => {
				onClose();
			}}
			onSubmit={() => {
				onSubmit();
			}}
			locale={locale}
			name={displayName || ''}
			entrypointId={ENTRYPOINT_ID}
			atlassianAccountId={userId ?? undefined}
			showTypeField={false}
			feedbackTitle={formatMessage(i18n.feedbackTitle)}
			feedbackTitleDetails={formatMessage(i18n.feedbackTitleDetails)}
			additionalFields={[
				{
					id: FEEDBACK_CONTEXT_ID,
					value: getFeedbackMetadata(),
				},
			]}
		/>
	);
};
